import CardsContext from '@/context/CardsContext';
import useCardsOnlyForContext from '@/hooks/cards/useCardsOnlyForContext';

export const CardsProvider = ({ children }: { children: React.ReactNode }) => {
	const useCardsOutcome = useCardsOnlyForContext();

	return (
		<CardsContext.Provider value={useCardsOutcome}>
			{children}
		</CardsContext.Provider>
	);
};
